var app = angular.module('leonardo');

var ContainsFilter = function () {
  var strContains = function(str, prefix) {
    if(typeof str === 'string' || str instanceof String){
      return (str.toLowerCase()+"").indexOf(prefix.toLowerCase()+"") > -1;
    }
  };

  return function (value, options) {
    var filtered = [];
    var name = '';
    if (value) {
      angular.forEach(options, function(item) {
        name = item.name ? item.name : item;
        if(strContains(name, value)){
          filtered.push(item);
        }
      });
    }
    else {
      angular.forEach(options, function(item) {
        filtered.push(item);
      });
    }

    return filtered;
  }
};

app.filter('contains', [ContainsFilter]);
